import { SET_SELECTED_SITES } from '../constants/site.constants';

export const setSelectedSite = site => ({ type: SET_SELECTED_SITES, site});